import { APIClient } from "helpers/api_helper";
import axios from "axios";

const api = new APIClient();

export async function createBankAccount(accountDetails) {
  try {
    const response = await axios.post(
      `merchant/add-bank-account`,
      accountDetails
    );

    if (!response.ok) {
      throw new Error("Bank account could not be created");
    }

    const data = await response.json();
    console.log(data.content);
    return data;
  } catch (error) {
    console.error(error);
    throw new Error("Bank account could not be created");
  }
}

export async function deleteBankAccounts(id) {
  try {
    const response = await axios.delete(`merchant/delete-bank-account`);
    if (!response.ok) {
      throw new Error("Primary Bank account cannot be removed");
    }

    const data = await response.json();
    console.log(data.content);
    return data;
  } catch (error) {
    console.error(error);
    throw new Error("You need at least one Bank Account");
  }
}
export async function getBankAccountApi() {
  try {
    const response = await api.get(`merchant/fetch-bank-account`, null);
    console.log(response);
    console.log(response);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error; // Ensure error is propagated to react-query
  }
}
